import React, { useEffect, useState, useMemo } from 'react';
import UserServices from '../services/OldProfileService.js';
import AdminServices from '../services/AdminServices';
import StateServices from '../services/StateServices';
import ViewUser from './View Model/viewThanaUser';
import Modal from 'react-modal';
import UserStatus from './TogelButton/UserStatus';
import UpdateProfile from './Update Model/UpdateThanaUser';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import Select from 'react-select';

Modal.setAppElement('#root');

function OldThanaUser() {
    const [loggedInUser, setLoggedInUser] = useState(null); // Store logged-in user data
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [search, setSearch] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const [statusFilter, setStatusFilter] = useState('');
    const [verifiedFilter, setVerifiedFilter] = useState('');
    const [districtFilter, setDistrictFilter] = useState('');
    const [policeStationFilter, setPoliceStationFilter] = useState('');
    const [districts, setDistricts] = useState([]);
    const [policeStations, setPoliceStations] = useState([]);
    const [data, setData] = useState(null);
    const [temp, setTemp] = useState(0);
    // Fetch logged-in user data
    useEffect(() => {
        const fetchLoggedInUser = async () => {
            try {
                const response = await AdminServices.getMyProfile();
                setLoggedInUser(response); // Set logged-in user data
            } catch (error) {
                console.error('Error fetching logged-in user:', error);
            }
        };
        fetchLoggedInUser();
    }, []);

    // Fetch districts on component mount
    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                const response = await StateServices.getAllDistrict();
                const districtsData = response.data || [];
                // Remove duplicates based on _id
                const uniqueDistricts = districtsData.filter((district, index, self) =>
                    index === self.findIndex((d) => d._id === district._id)
                );
                setDistricts(uniqueDistricts);
            } catch (error) {
                console.error('Failed to fetch districts', error);
            }
        };
        fetchDistricts();
    }, []);

    // Fetch police stations on component mount
    useEffect(() => {
        const fetchPoliceStations = async () => {
            try {
                const response = await StateServices.getAllThana();
                const stationsData = response.data || [];
                // Remove duplicates based on _id
                const uniqueStations = stationsData.filter((station, index, self) =>
                    index === self.findIndex((s) => s._id === station._id)
                );
                setPoliceStations(uniqueStations);
            } catch (error) {
                console.error('Failed to fetch police stations', error);
            }
        };
        fetchPoliceStations();
    }, []);

    // Reset to page 1 when filters change (except currentPage itself)
    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [search, statusFilter, verifiedFilter, districtFilter, policeStationFilter]);

    // Fetch data from backend with filters
    useEffect(() => {
        UserServices.getcircleThanaProfilesOld(currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter).then((res) => {
            setData(res);
        }).catch((error) => {
            console.log(error);
        });
    }, [currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter, temp]);

    const handleEditDetails = (thana) => {
        setSelectedEdit(thana);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };
    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };

    const handleViewDetails = (user) => {
        setSelectedUser(user);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        // setSelectedUser(null);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1);
    };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };

    const usersPerPage = 50;

    // Format districts for react-select (unique by _id)
    const districtOptions = useMemo(() => {
        const uniqueDistricts = districts.filter((district, index, self) =>
            index === self.findIndex((d) => d._id === district._id)
        );
        return uniqueDistricts.map(district => ({
            value: district._id,
            label: district.name
        }));
    }, [districts]);

    // Format police stations for react-select (unique by _id, filtered by district)
    const policeStationOptions = useMemo(() => {
        let filteredStations = policeStations;
        
        // Filter by district if selected
        if (districtFilter) {
            filteredStations = policeStations.filter((station) => {
                const stationDistrictId = station.district?._id || station.district;
                return stationDistrictId === districtFilter || stationDistrictId?.toString() === districtFilter;
            });
        }
        
        // Remove duplicates based on _id
        const uniqueStations = filteredStations.filter((station, index, self) =>
            index === self.findIndex((s) => s._id === station._id)
        );
        
        return uniqueStations.map(station => ({
            value: station._id,
            label: station.name
        }));
    }, [policeStations, districtFilter]);

    // Get selected values for react-select
    const selectedDistrict = useMemo(() => 
        districtOptions.find(opt => opt.value === districtFilter) || null,
        [districtOptions, districtFilter]
    );

    const selectedPoliceStation = useMemo(() => 
        policeStationOptions.find(opt => opt.value === policeStationFilter) || null,
        [policeStationOptions, policeStationFilter]
    );

    // Data is now filtered on the backend, so we just use the data directly
    const filteredUsers = data?.data || [];
    const count = data?.totalProfiles || 0;

    const generateExcel = () => {
        const filteredData = filteredUsers?.map((user, index) => ({
            "S.No": index + 1,
            UserType: user?.user?.name,
            UserMobileNo: user?.user?.mobileNo,
            Name: user?.name,
            MobileNo: user?.mobileNo,
            AadharNo: user?.aadharNo,
            State: user?.permanentAddress?.state?.name,
            District: user?.permanentAddress?.district?.name,
            PoliceStation: user?.permanentAddress?.policeStation?.name,
            Age: user?.age,
            Status: user?.status,
        }));

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Users');

        XLSX.writeFile(wb, 'user_data.xlsx');
    };

    return (
        <div className="right_col" role="main">
            <div className="title-box">
                <h2>Satyapan <span className="badge bg-warning">{count}</span></h2>
            </div>
            <div className="sub-title-box">
                <div className="sub-title-box-left">
                    {/* <p>Satyapan List</p> */}
                </div>
                <div className="sub-title-box-right">
                    <button className="excel-btn" onClick={generateExcel}>
                        <img src="img/excel.svg" alt="Excel" />Download
                    </button>
                </div>
            </div>
            <div className="container-box px-0 user-manager">
                <div className="container-box-top-header px-4">
                    <div className="container-box-top-header-left-2">
                        <input
                            type="search"
                            name="search"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <button className="search-btn">Search</button>
                        
                        {/* Verified Filter Dropdown */}
                        <select
                            className="filter-dropdown"
                            value={verifiedFilter}
                            onChange={(e) => setVerifiedFilter(e.target.value)}
                            style={{
                                marginLeft: '10px',
                                padding: '8px 12px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                fontSize: '14px',
                                cursor: 'pointer'
                            }}
                        >
                            <option value="">All Verified</option>
                            <option value="Valid">Valid</option>
                            <option value="Invalid">Invalid</option>
                        </select>
                        
                        {/* Status Filter Dropdown */}
                        <select
                            className="filter-dropdown"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{
                                marginLeft: '10px',
                                padding: '8px 12px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                fontSize: '14px',
                                cursor: 'pointer'
                            }}
                        >
                            <option value="">All Status</option>
                            <option value="Verify">Verify</option>
                            <option value="UnVerify">UnVerify</option>
                        </select>

                        {/* District Filter Dropdown - Searchable */}
                        <div style={{ marginLeft: '10px', minWidth: '200px', display: 'inline-block' }}>
                            <Select
                                value={selectedDistrict}
                                onChange={(selectedOption) => {
                                    setDistrictFilter(selectedOption ? selectedOption.value : '');
                                    setPoliceStationFilter(''); // Reset police station when district changes
                                }}
                                options={districtOptions}
                                placeholder="All Districts"
                                isSearchable
                                isClearable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px',
                                        fontSize: '14px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                    })
                                }}
                            />
                        </div>

                        {/* Police Station Filter Dropdown - Searchable */}
                        <div style={{ marginLeft: '10px', minWidth: '200px', display: 'inline-block' }}>
                            <Select
                                value={selectedPoliceStation}
                                onChange={(selectedOption) => {
                                    setPoliceStationFilter(selectedOption ? selectedOption.value : '');
                                }}
                                options={policeStationOptions}
                                placeholder="All Police Stations"
                                isSearchable
                                isClearable
                                isDisabled={!districtFilter && false}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px',
                                        fontSize: '14px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="container-box-inner">
                    <table id="example" className="table table-striped" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>App User</th>
                                <th>Satyapan Name</th>
                                <th>Aadhar No.</th>
                                <th>Mobile No.</th>
                                <th>Profession</th>
                                <th>State</th>
                                <th>District</th>
                                <th>Police Station</th>
                                <th>Verification ID</th>
                                <th>Register Date</th>
                                {/* <th>Status Label</th> */}
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers?.map((user, index) => (
                                <tr key={user?._id}>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {index + 1 + (currentPage - 1) * usersPerPage}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        <span >{user?.user?.name}</span>
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.name}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.aadharNo}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.mobileNo}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.profession?.profession || 'N/A'}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.presentAddress?.state?.name || 'N/A'}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.presentAddress?.district?.name || 'N/A'}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.presentAddress?.policeStation?.name || 'N/A'}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {user?.presentAddress?.policeStation?.code && user?.verificationId && user?.presentAddress?.district?.code
                                            ? `${user.presentAddress.policeStation.code} ${user.verificationId} ${user.presentAddress.district.code}`
                                            : user?.presentAddress?.policeStation?.code || user?.verificationId || user?.presentAddress?.district?.code
                                                ? user.presentAddress.policeStation.code || user.verificationId || user?.presentAddress?.district?.code
                                                : 'N/A'}
                                    </td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        {formatDate(user?.createdAt)}
                                    </td>
                                    {/* <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                  <button
                                    className="view-details-btn"
                                    style={{
                                      backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656',
                                      color: 'white'
                                    }}>
                                    {user?.status}
                                  </button>
                                </td> */}
                                    <td className="status-toggle" style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}><UserStatus user={user} page={"user"} /></td>
                                    <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                                        <div className="action_toggle_outer">
                                            <button
                                                className="action_toggle"
                                                onClick={() => toggleActionMenu(index)}
                                            >
                                                <i className="fa fa-ellipsis-v" />
                                            </button>
                                            {activeIndex === index && (
                                                <div className="action_toggle_content product-edit show d-block">
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                <i className="fa fa-close" />
                                                            </button>
                                                        </li>
                                                        {/* <li>
                                                            <button className="edit" onClick={() => handleEditDetails(user)}>Edit</button>
                                                        </li> */}
                                                        <li>
                                                            <button className="view-details-btn" onClick={() => handleViewDetails(user)}>View</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    {/* <td>
                                        <button className="view-details-btn" onClick={() => handleViewDetails(user)}>
                                            View
                                        </button>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="pagination">
                    <ReactPaginate
                        pageCount={Math.ceil(count / usersPerPage)}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        initialPage={currentPage - 1}
                        pageLinkClassName={'page-link'}
                        previousLinkClassName={'page-link'}
                        nextLinkClassName={'page-link'}
                        pageClassName={'page-item'}
                        previousClassName={'page-item'}
                        nextClassName={'page-item'}
                        disabledClassName={'disabled'}
                    />
                </div>
            </div>

            <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeEditModal}
                contentLabel="Edit Category"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <UpdateProfile selectedData={selectedEdit} closeModal={closeEditModal} onSuccess={() => setTemp(temp + 1)} />
            </Modal>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="User Details"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <ViewUser user={selectedUser} closeModal={closeModal} />
            </Modal>
        </div>
    );
}

export default OldThanaUser;
